<template>
    <TopBarVue/>
    <div id="content">
      <router-view />
    </div>
    <Footerbar/>
</template>

<script>
import TopBarVue from "@/layouts/TopBar";
import Footerbar from "@/layouts/Footer.vue"
export default {
  name: "App",
  components: {
    TopBarVue,
    Footerbar
  },
  data(){
    return{
      data_toggle :'',      
      databs:"",
    }
  },
};
</script>

<style>
#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

}
.tools_name li button {
  width: 140px;
}
</style>
